import { FormikProvider, useFormik } from 'formik'
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

import Steppor from '../../../../../components/AntdSteps/Steps'
import {
  buildJobRolePayload,
  generateFormikMap,
  getTitle,
  initialRoleValues,
  normalizeEligibilityCriteria,
  stripHtml,
  validationRoleSchema,
} from '../../../../../helpers/formHelpers'
import { useDataFetch } from '../../../../../hooks/useDataFetch'
import { debounce } from '../../../../../utils/debounce'
import { permittedSubEvents } from '../../../../../utils/permissionsValidation'
import CloseRoleDrawer from 'components/CloseRolePopup'
import LoadingOverlay from 'modules/CorporateDashboardPage2/Container/components/LoadingOverlay'
import {
  getCourses,
  getEligibilityCriteriaQualification,
  getLocations,
} from '../../../actions'
import Header from '../Header'
import {
  Container,
  LastDiv,
  LeftDiv,
  RightDiv,
  StickyDiv,
} from '../Style/style'
import { FormBottomSpacing } from './style/style'
import QualificationSelectionBubbleWithDummyData from './Partials/EligibiltyCriteria/QualidicationSelectionBubble'
import { transformPreviewData } from './Partials/EligibiltyCriteria'
import { Spin } from 'antd'

import ApprovedModelIcon from 'components/icons/ApprovedModelIcon'
import SuccessMessage from 'utils/SuccessMessage'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'

import { POPUP_CONFIGS } from '../../../../../utils/const'

const RoleEntryForm = ({
  getUserList,
  corporateData,
  postCorporateJobRole,
  listOfSkills,
  listOfDegree,
  updateJobRole,
  createQuestionarie,
  getAllQuestionarieList,
  allQuestionarieList,
  roleData,
  getSingleRoleData,
  getYearOfPassing,
  yearOfPassing,
  getAllQuestionBankList,
  getSingleQuestionarie,
  editQuestionarie,
  deleteQuestion,
  createQuestionarieBank,
  getListOfSkills,
  getPreviewData,
  setCollegeDrawer,
  jobId,
  setUpdateTrigger,
  fetchRoleDetails,
  previewData,
  getStepper,
  stepData,
  setStepData,
  currentStep,
  setCurrentStep,
  corporateDetails,
  onFormValuesChange,
  onSelectedCoursesChange,
  onIsForAllChange,
  publishRole
}) => {
  const [courseData, setCourseData] = useState([])
  const [selectedCourses, setSelectedCourses] = useState([])
  const [isAllSelected, setIsAllSelected] = useState([])
  const [originalFormValues, setOriginalFormValues] = useState(null)
  const [isBubbleLoading, setIsBubbleLoading] = useState(false)
  const [roundsClicked, setroundsClicked] = useState(false)
  const [buttonLoading, setButtonLoading] = useState(false)
  const [publishLoading, setPublishLoading] = useState(false)
  const [republishLoading, setRepublishLoading] = useState(false)
  const navigate = useNavigate()
  const formRef = useRef()
  const [search, setSearch] = useState({
    degree: '',
    skill: '',
    selectedType: 'ALL',
    cities: '',
  })
  let {
    data: skillList,
    refetch: skillRefetch,
    loading: skillLoading,
  } = useDataFetch(getListOfSkills, [search?.skill], [search?.skill])
  const payload = {
    searchValue: search?.degree ?? '',
    searchType: search?.selectedType,
  }

  const {
    data: degreeList,
    refetch: degreeRefetch,
    loading: degreeLoading,
  } = useDataFetch(getCourses(payload), [payload], [search?.degree])
  const { data: locationList, loading: locationLoading } = useDataFetch(
    getLocations({ searchValue: search.cities }),
    [search.cities],
    [search.cities]
  )
  const {
    data: questionList,
    loading: allQuestionarieListLoading,
    refetch: questionRefetch,
  } = useDataFetch(getAllQuestionarieList, [jobId], [jobId])

  const handleRepublishRole = () => {
    return new Promise(resolve => {
      setPopupConfig({
        ...POPUP_CONFIGS.CREATE_NEW_GROUP,
        description: (
          <span>
            Are you sure you want to <b>Republish the Role</b>?
          </span>
        ),
        icon: ApprovedModelIcon,
        onApprove: async () => {
          setRepublishLoading(true)
          try {
            await handleNext(false, 7, true)
            await handlePublishClick()
            setIsEdited(false)
            setIsDateOnlyEdited(false)
          } finally {
            setRepublishLoading(false)
          }
        },
        onClose: () => {
          setPopupConfig(null)
          resolve()
        },
      })
    })
  }
  const formik = useFormik({
    initialValues: initialRoleValues,
    validationSchema: validationRoleSchema,
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    context: {
      publishDisabled,
      originalMaxCompensation: roleData?.maxCompensation || 0,
      jobCategory: initialRoleValues?.jobDetails?.jobCategory || '', // Use initial values
    },

    onSubmit: async values => { },
  })
  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleSubmit,
    handleChange,
    setTouched,
    resetForm,
    setErrors,
    validateForm,
    handleBlur,
  } = formik

  const date = new Date()

  // Notify parent of form value changes
  useEffect(() => {
    if (onFormValuesChange) {
      onFormValuesChange(values.elgibilty)
    }
  }, [values.elgibilty.qualification, values.elgibilty.eligibilityCriteria, onFormValuesChange])

  // Notify parent of selected courses changes
  useEffect(() => {
    if (onSelectedCoursesChange) {
      onSelectedCoursesChange(selectedCourses)
    }
  }, [selectedCourses, onSelectedCoursesChange])

  // Initialize selectedCourses from previewData on first load (covers direct navigation to step 4)
  useEffect(() => {
    if (previewData?.eligibilityCriteria?.length && selectedCourses.length === 0) {
      const transformed = transformPreviewData(previewData)
      if (transformed.some(arr => arr?.length > 0)) {
        setSelectedCourses(transformed)
      }
    }
  }, [previewData])

  // Notify parent when isForAll changes (Off Campus / Lateral toggle)
  useEffect(() => {
    if (onIsForAllChange) {
      onIsForAllChange(values.jobDetails.isForAll)
    }
  }, [values.jobDetails.isForAll, onIsForAllChange])

  // Handles publish: Off Campus publishes directly, Campus opens college drawer
  const handlePublishClick = async () => {
    if (values.jobDetails.isForAll === true) {
      try {
        setPublishLoading(true)
        setButtonLoading(true)
        const payload = {
          groupIds: [],
          degreeStreamMapIds: [],
          instituteCampusIds: [],
        }
        const result = await publishRole(jobId, payload)
        if (result?.message === 'Job Role Floated Institue Successfully') {
          SuccessMessage('Role published successfully')
          navigate('/rolePage')
        } else {
          ErrorMessage('Role publish failed, please try again')
        }
      } catch (err) {
        ErrorMessage('Role publish failed, please try again')
      } finally {
        setPublishLoading(false)
        setButtonLoading(false)
      }
    } else {
      setCollegeDrawer(true)
    }
  }

  const [addNewDrawer, setAddNewDrawer] = useState(false)
  const [isEdited, setIsEdited] = useState(false)

  const [isDateOnlyEdited, setIsDateOnlyEdited] = useState(false)
  const [secondUpdated, setSecondUpdated] = useState(false)
  const permission = useSelector(state => state?.auth?.permissions)
  const subEvents = permittedSubEvents(permission, 'Roles', 'New Role')
  const [popupConfig, setPopupConfig] = useState(null)

  const StepContainer = stepData[currentStep]?.component
  const debouncedSearch = debounce(async (searchValue, key) => {
    setSearch(prev => ({
      ...prev,
      [key]: searchValue,
      // selectedType: values?.elgibilty?.qualification,
    }))
  }, 400)

  const handleSearch = (searchValue, key) => {
    debouncedSearch(searchValue, key)
  }

  // const handleQualicationChange = value => {
  //   setSearch({ ...search, searchType: value })
  // }

  // Reset form when creating a new role (no jobId)
  useEffect(() => {
    if (!jobId) {
      setOriginalFormValues(null)
      resetForm()
    }
  }, [jobId])

  useLayoutEffect(() => {
    if (!roleData || !jobId || Object.keys(roleData).length === 0) return
    const apiToFormikMap = generateFormikMap(initialRoleValues)
    setFieldValue(
      'interviewWorkFlow.rounds',
      roleData.interviewWorkFlow?.rounds || []
    )
    if (roleData?.externalLink) {
      setFieldValue('jobDetails.isExternalJob', true)
      setFieldValue('jobDetails.externalLink', roleData?.externalLink)
    }
    if (roleData?.jobRoleSkills?.length > 0) {
      setFieldValue('elgibilty.jobRoleSkills', roleData?.jobRoleSkills)

    }
    if (roleData?.eligibilityCriteria?.length > 0) {
      setFieldValue('elgibilty.eligibilityCriteria', roleData?.eligibilityCriteria)

    }
    Object.entries(apiToFormikMap).forEach(([apiField, formikPath]) => {
      if (roleData[apiField] !== undefined) {
        setFieldValue(formikPath, roleData[apiField])

        // Set original max compensation for validation
        if (apiField === 'maxCompensation' && roleData[apiField]) {
          setFieldValue('originalMaxCompensation', Number(roleData[apiField]))
        }
        if (
          (apiField === 'yearOfExperience' || apiField == 'gigsDuration') &&
          roleData[apiField]
        ) {
          const arr = roleData[apiField]

          if (apiField == 'gigsDuration') {
            const result = []
            if (arr && Array?.isArray(arr)) {
              arr?.forEach(num => {
                const [intPart, decPart] = num?.toString().split('.')
                result.push(parseInt(intPart, 10))
                if (decPart !== undefined) {
                  result?.push(parseInt(decPart, 10))
                }
              })
            } else {
              console.warn('arr is not an array or is null/undefined:', arr)
            }
            const startYear = (result?.[0] || 0) + (result?.[1] || 0) / 10 // 3 + 5/10 = 3.5
            const endYear = (result?.[2] || 0) + (result?.[3] || 0) / 10 // 6 + 0/10 = 6.0

            // Validate that first and third values are not the same
            if (startYear >= endYear) {
              setFieldValue(
                'jobDetails.gigsDurationError',
                'End year cannot be earlier than start year'
              )
            } else {
              setFieldValue('jobDetails.gigsDurationError', '')
            }

            setFieldValue('jobDetails.gigsDuration', {
              startYear: Number(result?.[0] || 0),
              startMonth: Number(result?.[1] || 0),
              endYear: Number(result?.[2] || 0),
              endMonth: Number(result?.[3] || 0),
            })
          }
          if (apiField === 'yearOfExperience') {
            const normalizedArr = arr.map(num => {
              // Convert to float with one decimal digit (e.g. 0 -> "0.0", 2 -> "2.0")
              return Number(num).toFixed(1)
            })

            const result = normalizedArr?.flatMap(str => {
              const [intPart, decPart] = str?.split('.')
              const parts = [parseInt(intPart, 10)]
              if (decPart !== undefined) {
                parts?.push(parseInt(decPart, 10))
              }
              return parts
            })

            setFieldValue('jobDetails.yearOfExperience', result)
            setFieldValue('jobDetails.experienceDuration', {
              startYear: Number(result[0]),
              startMonth: Number(result[1]),
              endYear: Number(result[2]),
              endMonth: Number(result[3]),
            })
          }
        }

        if (apiField === 'gigsDuration' && roleData[apiField]) {
          const array = roleData[apiField]
          const res = Array.isArray(array)
            ? array.flatMap(num => {
              const [intPart, decPart] = num.toString().split('.')
              return [parseInt(intPart, 10), parseInt(decPart || 0, 10)]
            })
            : []
          const startYear = (res?.[0] || 0) + (res?.[1] || 0) / 10 // 3 + 5/10 = 3.5
          const endYear = (res?.[2] || 0) + (res?.[3] || 0) / 10 // 6 + 0/10 = 6.0

          // Validate that first and third values are not the same
          if (startYear >= endYear) {
            setFieldValue(
              'jobDetails.gigsDurationError',
              'End year cannot be earlier than start year'
            )
          } else {
            setFieldValue('jobDetails.gigsDurationError', '')
          }

          setFieldValue('jobDetails.gigsDuration', {
            startYear: res[0],
            startMonth: res[1],
            endYear: res[2],
            endMonth: res[3],
          })
        }
      }
    })

    // Map applicationFormTemplate from API to applicationForm in formik
    if (roleData?.applicationFormTemplate) {
      setFieldValue('applicationForm', roleData.applicationFormTemplate)
    }

    // Remove the originalFormValues setting from here
    if (jobId) {
      ; (async () => {
        if (!jobId || !roleData) return // wait for data

        const currentState = Number(roleData?.currentState)
        const nextStep =
          roleData?.status === 1 || currentState >= 6 ? 6 : currentState + 1
        setCurrentStep(nextStep)
        const newUrl = `/roles/edit-role/${jobId}?CS=${nextStep}`
        window.history.replaceState({}, '', newUrl)
        //navigate(`/roles/edit-role/${jobId}/${nextStep}`, { replace: true });
        const stepKeys = Object.keys(formik.values)

        setStepData(prev =>
          prev.map((step, idx) => {
            const key = stepKeys[idx]

            let completed
            if (roleData?.status === 1) {
              completed = true
            } else if (
              key === 'qualifyQuestions' &&
              roleData?.questionBankRoleMap?.length > 0
            ) {
              completed = true
            } else {
              completed = idx <= currentState
            }
            return { ...step, completed }
          })
        )
        // Remove this line from here
        // setOriginalFormValues(JSON.parse(JSON.stringify(formik.values)))
      })()
    }

  }, [roleData, jobId])
  // Add this new useEffect to properly set originalFormValues
  useEffect(() => {
    if (
      roleData &&
      Object.keys(formik.values).length > 0 &&
      !originalFormValues
    ) {
      // Wait for form values to stabilize
      const timer = setTimeout(() => {
        // Check if all expected fields are populated
        const hasAllRequiredFields = Object.keys(formik.values).every(
          stepKey => {
            const stepValues = formik.values[stepKey]
            return stepValues && Object.keys(stepValues).length > 0
          }
        )

        if (hasAllRequiredFields) {
          setOriginalFormValues(JSON.parse(JSON.stringify(formik.values)))
        }
      }, 500) // Increased delay to ensure all async operations complete

      return () => clearTimeout(timer)
    }
  }, [roleData, formik.values, originalFormValues])
  useEffect(() => {
    if (jobId) {
      const newUrl = `/roles/edit-role/${jobId}?CS=${currentStep}`
      navigate(newUrl, { replace: true })
    }
  }, [currentStep, jobId, navigate])

  // Add fallback useEffect to ensure originalFormValues is set
  useEffect(() => {
    if (roleData && formik.values && !originalFormValues) {
      // Fallback: set after a longer delay if still not set
      const fallbackTimer = setTimeout(() => {
        if (!originalFormValues && Object.keys(formik.values).length > 0) {
          setOriginalFormValues(JSON.parse(JSON.stringify(formik.values)))
        }
      }, 2000)

      return () => clearTimeout(fallbackTimer)
    }
  }, [roleData, formik.values, originalFormValues])
  const [rePublishedPublishDisabled, setRePublishedPublishDisabled] =
    useState(false)
  const [publishDisabled, setRublishDisabled] = useState(false)
  useEffect(() => {
    setRublishDisabled(roleData?.status == 1 && !roleData?.republishedDate)
    setFieldValue(
      'publishDisabled',
      roleData?.status == 1 && !roleData?.republishedDate
    )
    setRePublishedPublishDisabled(
      roleData?.status == 1 && roleData?.republishedDate ? true : false
    )
    setSecondUpdated(false)
  }, [roleData, secondUpdated])

  const handleNext = async (fromTab = false, value, forRepublish = false) => {
    const errors = await validateForm()
    setroundsClicked(true)
    const stepKeys = Object.keys(values)
    const currentKey = stepKeys[currentStep]
    const errorsForCurrentStep = errors[currentKey] || {}
    if (currentKey === 'qualifyQuestions' && !addNewDrawer) {
      Object.keys(errorsForCurrentStep).forEach(key => {
        delete errorsForCurrentStep[key]
      })
    }
    const fieldsOrder = Object.keys(values[currentKey] || {})
    const firstErrorField =
      fieldsOrder.find(field => errorsForCurrentStep[field]) || null
    // If no errors in current step, focus on first field
    if (
      Object.keys(errorsForCurrentStep).length === 0 &&
      fieldsOrder.length > 0
    ) {
      const stepContainer = document.querySelector('.current-step-container')
      const firstField = fieldsOrder[0]
      const element =
        stepContainer?.querySelector(`[name="${currentKey}.${firstField}"]`) ||
        stepContainer?.querySelector(`[id="${currentKey}.${firstField}"]`) ||
        stepContainer?.querySelector(
          'input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )

      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
        element.focus()
      }
    }

    const touchedFields = {}
    fieldsOrder.forEach(field => {
      if (errorsForCurrentStep[field]) {
        touchedFields[`${currentKey}.${field}`] = true
      }
    })
    setTouched(touchedFields)

    // Custom validation for ApplicationForm - check if custom questions have values
    if (currentStep === 4 && values.applicationForm?.customQuestions) {
      const choiceTypes = ['MULTIPLE_CHOICE', 'CHECKBOXES', 'DROPDOWN']
      const invalidQuestions = values.applicationForm.customQuestions.filter((q) => {
        const noText = !q.question || q.question.trim() === ''
        const noOptions =
          choiceTypes.includes(q.responseType) &&
          (!Array.isArray(q.options) ||
            !q.options.some((opt) => typeof opt === 'string' && opt.trim() !== ''))
        return noText || noOptions
      })

      if (invalidQuestions.length > 0) {
        // Trigger validation state to show inline errors
        window.dispatchEvent(new CustomEvent('triggerValidation', { detail: { show: true } }))

        // Focus on first invalid question
        const questionInput = document.querySelector(`input[placeholder="Enter question"]`)

        if (questionInput) {
          questionInput.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
          questionInput.focus()
        }

        return
      }
    }

    if (firstErrorField) {
      const stepContainer = document.querySelector('.current-step-container')
      const element =
        stepContainer?.querySelector(
          `[name="${currentKey}.${firstErrorField}"]`
        ) ??
        stepContainer?.querySelector(`[id="${currentKey}.${firstErrorField}"]`)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
        element.focus()
      }
    } else {
      if (currentStep === 0 && !jobId) {
        setCurrentStep(1)
      }
      if (!forRepublish && roleData?.status == 1) {
        // Safety check: if originalFormValues is missing, set it now
        if (roleData && !originalFormValues && publishDisabled) {
          setOriginalFormValues(JSON.parse(JSON.stringify(values)))
          // Skip the edit check for this iteration
          return
        }

        let isFieldEdited = false
        const allEditedFields = []

        // Compare with roleData to check for edits
        if (
          roleData &&
          originalFormValues &&
          (publishDisabled || rePublishedPublishDisabled)
        ) {
          const currentStepValues = values[currentKey] || {}
          const originalStepValues = originalFormValues[currentKey] || {}

          const editedFields = []

          const fieldsToSkip = ['yearOfExperience', 'experienceDuration']
          Object.keys(currentStepValues).forEach(field => {
            if (fieldsToSkip.includes(field)) {
              return
            }
            const currentValue = currentStepValues[field]
            const originalValue = originalStepValues[field]
            // Normalize experienceDuration numbers before comparing (null/undefined -> 0, cast to Number)
            if (field === 'experienceDuration') {
              const normalizeNumericValues = obj => {
                if (obj && typeof obj === 'object') {
                  const normalized = {}
                  Object.keys(obj).forEach(key => {
                    const value = obj[key]
                    normalized[key] =
                      value === null || value === undefined ? 0 : Number(value)
                  })
                  return normalized
                }
                return obj
              }
              const normalizedCurrent = normalizeNumericValues(currentValue)
              const normalizedOriginal = normalizeNumericValues(originalValue)
              if (
                JSON.stringify(normalizedCurrent) !==
                JSON.stringify(normalizedOriginal)
              ) {
                editedFields.push({
                  field: `${currentKey}.${field}`,
                  currentValue: normalizedCurrent,
                  originalValue: normalizedOriginal,
                })
              }
              return
            }

            if (
              JSON.stringify(currentValue) !== JSON.stringify(originalValue)
            ) {
              editedFields.push({
                field: `${currentKey}.${field}`,
                currentValue,
                originalValue,
              })
            }
          })
          // Check all steps for edits
          stepKeys.forEach(stepKey => {
            const stepValues = values[stepKey] || {}
            const stepOriginalValues = originalFormValues[stepKey] || {}

            Object.keys(stepValues).forEach(field => {
              const currentValue = stepValues[field]
              const originalValue = stepOriginalValues[field]

              // Some step components mutate formik values purely for display the
              // first time their step is opened (validation-error helpers, shape
              // wrapping). Those must NOT be treated as user edits — otherwise
              // simply navigating through the steps to Preview flips the button
              // to "Update". Canonicalize/skip those fields so only real value
              // changes count.

              // Validation-error helper fields (gigsDurationError,
              // yearOfExperienceError, projectDurationError, ...) are set on step
              // visit and never persisted — they are never a real edit.
              if (/Error$/.test(field)) {
                return
              }

              // eligibilityCriteria is stored flat ([items]) but the Eligibility
              // step normalizes it to an array-of-arrays ([[items]]) on mount.
              // Compare both sides in the same canonical (nested, non-empty) form.
              if (field === 'eligibilityCriteria') {
                const canonicalCriteria = v => {
                  if (!Array.isArray(v)) return []
                  const nested = Array.isArray(v[0]) ? v : v.length ? [v] : []
                  return nested.filter(a => Array.isArray(a) && a.length > 0)
                }
                if (
                  JSON.stringify(canonicalCriteria(currentValue)) !==
                  JSON.stringify(canonicalCriteria(originalValue))
                ) {
                  allEditedFields.push({
                    field: `${stepKey}.${field}`,
                    currentValue,
                    originalValue,
                  })
                }
                return
              }

              // gigsDuration flips between [] and an all-empty
              // { startYear, startMonth, endYear, endMonth } object on visit for
              // non-gig roles. Treat both empty shapes as equal.
              if (field === 'gigsDuration') {
                const hasValue = x =>
                  x !== undefined && x !== null && Number(x) !== 0
                const canonicalGigs = v => {
                  if (Array.isArray(v)) return v.some(hasValue) ? v : null
                  if (v && typeof v === 'object')
                    return Object.values(v).some(hasValue) ? v : null
                  return v ?? null
                }
                if (
                  JSON.stringify(canonicalGigs(currentValue)) !==
                  JSON.stringify(canonicalGigs(originalValue))
                ) {
                  allEditedFields.push({
                    field: `${stepKey}.${field}`,
                    currentValue,
                    originalValue,
                  })
                }
                return
              }

              // Handle experienceDuration specially across steps as well
              const fullPath = `${stepKey}.${field}`
              const normalizeNumericValues = obj => {
                if (obj && typeof obj === 'object') {
                  const normalized = {}
                  Object.keys(obj).forEach(key => {
                    const value = obj[key]
                    normalized[key] =
                      value === null || value === undefined ? 0 : Number(value)
                  })
                  return normalized
                }
                return obj
              }
              if (
                field === 'yearOfExperience' ||
                fullPath === 'jobDetails.yearOfExperience'
              ) {
                const normalizedCurrent = normalizeNumericValues(currentValue)
                const normalizedOriginal = normalizeNumericValues(originalValue)

                if (
                  JSON.stringify(normalizedCurrent) !==
                  JSON.stringify(normalizedOriginal)
                ) {
                  allEditedFields.push({
                    field: `${stepKey}.${field}`,
                    currentValue: normalizedCurrent,
                    originalValue: normalizedOriginal,
                  })
                }
                return
              }

              // Skip interviewWorkFlow.rounds field
              const fieldPath = `${stepKey}.${field}`
              if (
                field === 'experienceDuration' ||
                fullPath === 'jobDetails.experienceDuration' ||
                stepKey === 'interviewWorkFlow' ||
                stepKey == 'corporateDetails' ||
                field == 'maxCompensation'
              ) {
                return
              }

              // Custom comparison for array fields with objects
              const isArrayFieldChanged = (current, original) => {
                if (!Array.isArray(current) || !Array.isArray(original)) {
                  return JSON.stringify(current) !== JSON.stringify(original)
                }

                // For jobRoleSkills, compare by skillId
                if (field === 'jobRoleSkills') {
                  const currentIds = current.map(item => item.skillId).sort()
                  const originalIds = original.map(item => item.skillId).sort()
                  return (
                    JSON.stringify(currentIds) !== JSON.stringify(originalIds)
                  )
                }

                // For application-form question arrays, deep-compare full content
                // (question text, required flag, options, responseType) — not just
                // ids — so editing an existing question is detected as an edit.
                if (field === 'mandatoryQuestions' || field === 'customQuestions') {
                  return JSON.stringify(current) !== JSON.stringify(original)
                }

                // For other array fields, compare by id if available
                if (
                  current.length > 0 &&
                  original.length > 0 &&
                  current[0]?.id
                ) {
                  const currentIds = current.map(item => item.id).sort()
                  const originalIds = original.map(item => item.id).sort()
                  return (
                    JSON.stringify(currentIds) !== JSON.stringify(originalIds)
                  )
                }

                // Default array comparison
                return JSON.stringify(current) !== JSON.stringify(original)
              }
              if (isArrayFieldChanged(currentValue, originalValue)) {
                allEditedFields.push({
                  field: `${stepKey}.${field}`,
                  currentValue,
                  originalValue,
                })
              }
            })
          })
          if (allEditedFields?.length != 0) {
            setIsEdited(true)
            isFieldEdited = true
            setIsDateOnlyEdited(false)
          } else {
            setIsEdited(false)
            isFieldEdited = false
          }
        }

        if (roleData && originalFormValues && allEditedFields?.length) {
          const isEndDateModified =
            allEditedFields?.length == 1 &&
            allEditedFields?.[0]?.field == 'jobDetails.endDate'

          if (isEndDateModified) {
            setIsDateOnlyEdited(true)
            setIsEdited(false)
          } else {
            setIsDateOnlyEdited(false)
            setIsEdited(isFieldEdited)
          }
        }

        if (!fromTab || !jobId) {
          setCurrentStep(currentStep >= 6 ? 6 : currentStep + 1)
        } else {
          setCurrentStep(value)
        }
      }
      // normal process - above for validate changes for second time edit

      setStepData(prev =>
        prev.map((step, idx) =>
          idx === currentStep ? { ...step, completed: true } : step
        )
      )
      if (currentStep === 1 && !jobId) {
        const arr = values?.jobDetails?.yearOfExperience || []

        // Group values in pairs [int, dec] → number int.dec
        const decimalResult = []
        for (let i = 0; i < arr.length; i += 2) {
          if (arr[i] !== undefined && arr[i + 1] !== undefined) {
            decimalResult.push(Number(`${arr[i]}.${arr[i + 1]}`)) // 👈 convert string → number
          }
        }
        const sanitizedJobRolePoc = Array.isArray(values?.corporateDetails?.jobRolePoc)
          ? values.corporateDetails.jobRolePoc.filter(p =>
            p && typeof p === 'object' && !Array.isArray(p) && Object.keys(p).length > 0
          )
          : []
        const payload = {
          corporateDetails: {
            ...values.corporateDetails,
            jobRolePoc: sanitizedJobRolePoc,
          },
          jobDetails: {
            ...values.jobDetails,
            gigsDuration: Array.isArray(values?.jobDetails?.gigsDuration)
              ? {}
              : values?.jobDetails?.gigsDuration,
            maxVacancies: !values?.jobDetails?.maxVacancies
              ? 0
              : values?.jobDetails?.maxVacancies,
            yearOfExperience: decimalResult || [],
          },
        }

        const response = await postCorporateJobRole(payload)
        const roleId = response?.data?.data?.jobRole?.id
        const postKey = {
          currentState: currentStep,
        }
        if (roleId) {
          navigate(`/roles/edit-role/${roleId}?CS=${2}`)
          getStepper(roleId, postKey)
          setCurrentStep(2)
        }
      } else {
        const newValues = buildJobRolePayload(
          values,
          currentStep,
          publishDisabled && forRepublish && isEdited && !isDateOnlyEdited
        )
        if (jobId && currentStep === 0 && !forRepublish) {
          setCurrentStep(1)
          return
        }
        if (
          (jobId && currentStep !== 0 && !publishDisabled && !rePublishedPublishDisabled) ||
          forRepublish ||
          (!jobId && currentStep > 1) // For new roles, call API for steps after step 1
        ) {
          setSearch({})
          if (jobId) {
            const postKey = {
              currentState: currentStep,
            }
            let response = await updateJobRole({ ...newValues }, jobId, setButtonLoading)
            if (response?.status === 200) {
              if (!fromTab || !jobId) {
                setCurrentStep(currentStep >= 6 ? 6 : currentStep + 1)
              } else {
                setCurrentStep(value)
              }

              await getStepper(jobId, postKey)
              await getSingleRoleData(1, jobId)
              setUpdateTrigger(true)
            }
          } else {
            // For new roles, create the job role
            const response = await postCorporateJobRole(newValues)
            const roleId = response?.data?.data?.jobRole?.id
            if (roleId) {
              navigate(`/roles/edit-role/${roleId}?CS=${currentStep}`)
            }

            if (!fromTab || !jobId) {
              setCurrentStep(currentStep >= 6 ? 6 : currentStep + 1)
            } else {
              setCurrentStep(value)
            }
          }
        }
      }

    }
  }

  const saveAsDraftJobRole = async values => {
    const arr = values?.jobDetails?.yearOfExperience || []

    // Group values in pairs [int, dec] → number int.dec
    const decimalResult = []
    for (let i = 0; i < arr.length; i += 2) {
      if (arr[i] !== undefined && arr[i + 1] !== undefined) {
        decimalResult.push(Number(`${arr[i]}.${arr[i + 1]}`)) // 👈 convert string → number
      }
    }
    const sanitizedJobRolePoc = Array.isArray(values?.corporateDetails?.jobRolePoc)
      ? values.corporateDetails.jobRolePoc.filter(p =>
        p && typeof p === 'object' && !Array.isArray(p) && Object.keys(p).length > 0
      )
      : []
    const payload = {
      corporateDetails: {
        ...values.corporateDetails,
        jobRolePoc: sanitizedJobRolePoc,
      },
      jobDetails: {
        ...values.jobDetails,
        gigsDuration: Array.isArray(values?.jobDetails?.gigsDuration)
          ? {}
          : values?.jobDetails?.gigsDuration,
        maxVacancies: !values?.jobDetails?.maxVacancies
          ? 0
          : values?.jobDetails?.maxVacancies,
        yearOfExperience: decimalResult || [],
      },
    }


    const response = await postCorporateJobRole(payload)

    if (response?.status === 200) {
      navigate(`/rolePage`)
    } else {
      message.error(response?.message)
    }
    // else {
    //   message.error(response?.message)
    // }
  }
  const validateCurrentStepAndSetCompleted = async () => {
    const stepKeys = Object.keys(formik.values)
    const currentKey = stepKeys[currentStep]

    // Skip validation for specific steps
    if (['preview', 'corporateDetails'].includes(currentKey)) {
      return
    }

    const allErrors = await formik.validateForm()

    const getIncompleteSteps = () => {
      const incompleteSteps = []
      const basicCompleteSteps = [1, 2, 3] // only these should be validated
      basicCompleteSteps.forEach(stepIndex => {
        const stepKey = Object.keys(formik.values)[stepIndex]
        const stepErrors = formik.errors[stepKey] || {}
        if (Object.keys(stepErrors).length > 0) {
          incompleteSteps.push(stepIndex)
        }
      })
      return incompleteSteps
    }

    const incompleteSteps = getIncompleteSteps()
    const errorsForCurrentStep = allErrors?.[currentKey] || {}

    if (incompleteSteps.length > 0) {
      const isOffCampus = formik.values?.jobDetails?.isForAll === true
      setStepData(prev =>
        prev.map((step, idx) => {
          // Only update 1,2,3
          if ([1, 2, 3].includes(idx)) {
            // For Off Campus roles, don't auto-complete Eligibility Criteria (step 3)
            // unless user is currently on that step
            if (isOffCampus && idx === 3 && currentStep !== 3) {
              return { ...step, completed: false }
            }
            return {
              ...step,
              completed: !incompleteSteps.includes(idx),
            }
          }
          // For steps 4,5,6 keep their old state
          return step
        })
      )
    }

    // 🔑 Re-check current step with custom logic
    setStepData(prev =>
      prev.map((step, idx) => {
        if (idx !== currentStep) return step

        let isCompleted = false

        if (currentKey === 'qualifyQuestions') {
          isCompleted = questionList?.length
            ? true
            : Object.keys(errorsForCurrentStep).length === 0
        } else if (currentKey === 'interviewWorkFlow') {
          const rounds = formik.values?.interviewWorkFlow?.rounds || []
          const hasAtLeastOneValidRound = rounds.some(
            r => r?.name?.trim() && r?.description?.trim()
          )
          isCompleted =
            Object.keys(errorsForCurrentStep).length === 0 &&
            hasAtLeastOneValidRound
        } else {
          isCompleted = Object.keys(errorsForCurrentStep).length === 0
        }

        return { ...step, completed: isCompleted }
      })
    )
  }

  const [stepDirty, setStepDirty] = useState(false)
  useEffect(() => {
    const stepKeys = Object.keys(formik.values)
    const currentKey = stepKeys[currentStep]

    // Skip preview/corporateDetails
    if (['preview', 'corporateDetails'].includes(currentKey)) return

    // If user changes something in the current step, mark it dirty
    const valuesForCurrentStep = formik.values[currentKey]
    if (valuesForCurrentStep && !stepDirty) {
      setStepDirty(true)
    }

    // Only validate after it's marked dirty
    if (stepDirty) {
      validateCurrentStepAndSetCompleted()
    }
  }, [formik.values, currentStep])

  const onTabChange = async value => {
    if (value >= currentStep) {
      await handleNext(true, value)
    } else {
      setCurrentStep(value)
    }
  }

  const handleBack = () => {
    setCurrentStep(currentStep - 1)
  }
  return (
    <>
      {popupConfig && (
        <CloseRoleDrawer
          description={<>{popupConfig.description}</>}
          Icon={popupConfig.icon}
          showDrawer={true}
          setShowDrawer={() => setPopupConfig(null)}
          onCloseClick={popupConfig.onClose}
          onApprove={popupConfig.onApprove}
          closeText={popupConfig.closeText}
          YesText={popupConfig.yesText}
          closeButtonHeight={popupConfig.closeButtonHeight}
          closeButtonWidth={popupConfig.closeButtonWidth}
          yesButtonHeight={popupConfig.yesButtonHeight}
          yesButtonWidth={popupConfig.yesButtonWidth}
        />
      )}
      <FormikProvider value={formik}>
        <form id="rolesForm" onSubmit={e => e.preventDefault()}>
          <Header
            isEditingRole={!jobId ? false : true}
            subEvents={subEvents}
            updateJobRole={updateJobRole}
            handleNext={
              currentStep === stepData.length - 1 ? handleSubmit : handleNext
            }
            values={values}
            setCollegeDrawer={setCollegeDrawer}
            onPublishClick={handlePublishClick}
            currentStep={currentStep}
            handleBack={handleBack}
            jobId={jobId}
            publishDisabled={publishDisabled}
            rePublishedPublishDisabled={rePublishedPublishDisabled}
            handleRepublishRole={handleRepublishRole}
            isEdited={isEdited}
            isDateOnlyEdited={isDateOnlyEdited}
            stepData={stepData}
            saveAsDraftJobRole={saveAsDraftJobRole}
            setroundsClicked={setroundsClicked}
            buttonLoading={buttonLoading}
          />
          <Container>
            <LeftDiv>
              <StickyDiv>
                <Steppor
                  steps={stepData}
                  current={currentStep}
                  onChange={onTabChange}
                  onTabChange={onTabChange}
                />
              </StickyDiv>
            </LeftDiv>
            <RightDiv wide={currentStep === 4}>
              <FormBottomSpacing>
                <div className="current-step-container">
                  {StepContainer && (
                    <React.Suspense fallback={<Spin />}>
                      <StepContainer
                        ref={formRef}
                        onValidationTrigger={() => window.dispatchEvent(new CustomEvent('triggerValidation', { detail: { show: true } }))}
                        rePublishedPublishDisabled={rePublishedPublishDisabled}
                        getAllQuestionarieList={getAllQuestionarieList}
                        allQuestionarieList={allQuestionarieList}
                        listOfSkills={skillList}
                        createQuestionarie={createQuestionarie}
                        skillLoading={skillLoading}
                        handleSearch={handleSearch}
                        listOfDegree={degreeList}
                        getListOfSkills={getListOfSkills}
                        courseData={courseData}
                        setCourseData={setCourseData}
                        getUserList={getUserList}
                        getYearOfPassing={getYearOfPassing}
                        yearOfPassing={yearOfPassing}
                        getEligibilityCriteriaQualification={
                          getEligibilityCriteriaQualification
                        }
                        degreeLoading={degreeLoading}
                        jobId={jobId}
                        getSingleRoleData={getSingleRoleData}
                        getAllQuestionBankList={getAllQuestionBankList}
                        getSingleQuestionarie={getSingleQuestionarie}
                        editQuestionarie={editQuestionarie}
                        deleteQuestion={deleteQuestion}
                        createQuestionarieBank={createQuestionarieBank}
                        addNewDrawer={addNewDrawer}
                        setAddNewDrawer={setAddNewDrawer}
                        corporateData={corporateData}
                        setFieldValue={setFieldValue}
                        roleData={roleData}
                        updateJobRole={updateJobRole}
                        publishDisabled={publishDisabled}
                        getPreviewData={getPreviewData}
                        locationList={locationList}
                        locationLoading={locationLoading}
                        setStepData={setStepData}
                        setSearch={setSearch}
                        setSelectedCourses={setSelectedCourses}
                        selectedCourses={selectedCourses}
                        isAllSelected={isAllSelected}
                        setIsAllSelected={setIsAllSelected}
                        search={search.degree}
                        skillRefetch={skillRefetch}
                        fetchRoleDetails={fetchRoleDetails}
                        previewData={previewData}
                        type={search.selectedType}
                        isBubbleLoading={isBubbleLoading}
                        currentStep={currentStep}
                        setIsBubbleLoading={setIsBubbleLoading}
                        data={questionList}
                        questionRefetch={questionRefetch}
                        allQuestionarieListLoading={allQuestionarieListLoading}
                        validateCurrentStepAndSetCompleted={
                          validateCurrentStepAndSetCompleted
                        }
                        getStepper={getStepper}
                        updatedRoleData={values}
                        status={roleData?.status}
                        corporateDetails={corporateDetails}
                        roundsClicked={roundsClicked}
                        setroundsClicked={setroundsClicked}
                      />
                    </React.Suspense>
                  )}
                </div>
              </FormBottomSpacing>
            </RightDiv>

            <LastDiv hidden={currentStep === 4}>
              {currentStep === 3 && (
                <QualificationSelectionBubbleWithDummyData
                  handleRemoveFilter={(...args) => console.log('remove', args)}
                  handleAllRemove={(...args) => console.log('remove all', args)}
                  checkAllCompleted={false}
                  isShow={true}
                  setCourseData={setCourseData}
                  setSelectedCourses={setSelectedCourses}
                  courseData={selectedCourses}
                  // handleQualicationChange={handleQualicationChange}
                  isAllSelected={isAllSelected}
                  setIsAllSelected={setIsAllSelected}
                  isLoading={isBubbleLoading}
                  publishDisabled={publishDisabled}
                  rePublishedPublishDisabled={rePublishedPublishDisabled}
                />
              )}
            </LastDiv>
          </Container>
        </form>
      </FormikProvider>
      <LoadingOverlay visible={publishLoading} message="Publishing role..." showBackground={false} />
      <LoadingOverlay visible={republishLoading} message="Updating role..." showBackground={false} />
    </>
  )
}

export default RoleEntryForm
